/// <amd-module name="Agile/Common/Redux/BacklogConfiguration/BacklogConfigurationActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { IBacklogConfiguration } from "./BacklogConfigurationContracts";

export const enum BacklogConfigurationActionTypes {
    BacklogConfigurationLoadedAction = "BacklogConfiguration/BacklogConfigurationLoaded"
}

export const BacklogConfigurationActions = {
    backlogConfigurationLoaded: (backlogConfiguration: IBacklogConfiguration) =>
        createAction(BacklogConfigurationActionTypes.BacklogConfigurationLoadedAction, { backlogConfiguration })
};

export type BacklogConfigurationActions = ActionsUnion<typeof BacklogConfigurationActions>;
